module.exports = __webpack_public_path__ + "static/media/repeat-square.8076016b.svg";